import { DsImageProps } from '@am92/react-design-system'

import { T_CURRENCY, T_SUBSCRIPTION_PLAN_NAMES } from './Subscription.Types'

import MASCOT_BIRD_VERSION_1 from '~/src/Assets/MASCOT/MASCOT_BIRD_VERSION_1'
import MASCOT_BIRD_VERSION_3 from '~/src/Assets/MASCOT/MASCOT_BIRD_VERSION_3'
import MASCOT_BIRD_VERSION_5 from '~/src/Assets/MASCOT/MASCOT_BIRD_VERSION_5'

export const CURRENCY_MAP: Record<T_CURRENCY, string> = {
  EUR: '€'
}

export const SUBSCRIPTION_IMAGE_MAP: Record<
  T_SUBSCRIPTION_PLAN_NAMES,
  DsImageProps['srcSet']
> = {
  ADVENTURE: MASCOT_BIRD_VERSION_1,
  PREMIUM: MASCOT_BIRD_VERSION_3,
  CHAMPION: MASCOT_BIRD_VERSION_5
}
